import {
  SnippetElement,
  defineElement,
  onClick,
  param,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/snippets/util-info/util-info.ts
var UtilInfo = class extends SnippetElement {
  constructor() {
    super();
    if (this.initial) {
      this.show();
    }
  }
  get message() {
    var _a;
    return (_a = this.messageOutput.textContent) != null ? _a : "";
  }
  set message(msg) {
    this.messageOutput.textContent = msg;
  }
  show(message) {
    if (message != null) {
      this.message = message;
    }
    this.classList.add("block");
    this.classList.remove("hidden");
  }
  hide() {
    this.classList.add("hidden");
    this.classList.remove("block");
  }
};
__decorateClass([
  param()
], UtilInfo.prototype, "initial", 2);
__decorateClass([
  query("[data-message]")
], UtilInfo.prototype, "messageOutput", 2);
__decorateClass([
  onClick("[data-close-error]")
], UtilInfo.prototype, "hide", 1);
UtilInfo = __decorateClass([
  defineElement("util-info")
], UtilInfo);
export {
  UtilInfo
};
